<template>
  <div class="text-primary" id="switchingOver">
    <div class="container py-5" style="max-width: 1500px;">
      
        <h2>We make switching easy</h2>
        <p class="lead">Investment property already managed by another real estate agent? Let us take the hassle out of switching...</p>

        <ul class="icon-list">
            <li>
                <h4>Step One</h4>
                <div class="icon"><img class="lazy" src="@/assets/content/step1.png" alt=""></div>
                <p>We meet with you to run through the Bricks & Mortar difference and how we will exceed your property management expectations.</p>
            </li>
            <li>
                <h4>Step Two</h4>
                <div class="icon"><img class="lazy" src="@/assets/content/step2.png" alt=""></div>
                <p>We liaise with your current Real Estate Agent and orchestrate the file transfer.</p>
            </li>
            <li>
                <h4>Step Three</h4>
                <div class="icon"><img class="lazy" src="@/assets/content/step3.png" alt=""></div>
                <p>Bricks & Mortar time the transfer of files so that there is no disruption of the rent.</p>
            </li>
            <li>
                <h4>Step Four</h4>
                <div class="icon"><img class="lazy" src="@/assets/content/step4.png" alt=""></div>
                <p>Upon collection of files, Bricks & Mortar attend property and get acquainted with tenant.</p>
            </li>
            <li>
                <h4>Step Five</h4>
                <div class="icon"><img class="lazy" src="@/assets/content/step5.png" alt=""></div>
                <p>That’s it! You can relax knowing that your property is in capable hands.</p>
            </li>

        </ul>

        <div class="video">
            <video controls="controls" poster="videos/switching-over.png" preload="none" width="100%"><source src="videos/switching-over.mp4" type="video/mp4"></video>
        </div>

        <a class="btn btn-outline-light" href="#" @click="scrollTo('switchcontact')">Switch Agents Today</a>
      
    </div>
  </div>
</template>

<style lang="scss">
    #switchingOver {
        padding-top: 60px;
        padding-bottom: 60px;
        background: #231f20;
        background-image: url("../assets/backgrounds/bricks.jpg");
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        color: white !important;
        text-align: center;

        @media (min-width: 992px) {
            background-attachment: fixed;
        }

        .lead {
            margin-bottom: 40px;
            margin-left: auto;
            margin-right: auto;
            max-width: 740px;
        }

        .icon-list {
            padding: 0;
            list-style: none;
            margin-bottom: 50px;

            @media (min-width: 768px) {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                overflow: hidden;
                margin-left: -20px;
                margin-right: -20px;
            }

            @media (min-width: 1200px) {
                margin-left: -30px;
                margin-right: -30px;
            }

            li {
                font-size: 14px;
                text-align: center;
                margin-bottom: 50px;

                @media (min-width: 768px) {
                    margin: 20px;
                    width: calc(50% - 40px);
                    font-size: 18px;
                }

                @media (min-width: 992px) {
                    margin: 20px 30px 30px;
                    width: calc(33.33% - 60px);
                }

                @media (min-width: 1200px) {
                    margin: 20px 30px 30px;
                    width: calc(20% - 60px);
                }
            }

            h4 {
                text-transform: uppercase;
                letter-spacing: 2px;
                font-size: 20px;
                margin-bottom: 30px;
            }

            .icon {
                margin-bottom: 20px;

                @media (min-width: 768px) {
                    margin-bottom: 30px;
                }

                img {
                    display: block;
                    margin: 0 auto;
                    height: 90px;
                }
            }
        }

        .video {
            margin: 0 auto 40px;
            max-width: 800px;
        }
    }
</style>

<script>
import $ from "jquery";

export default {
  methods: {
    scrollTo(element) {
      let scrollPoint = $("#" + element).offset().top - 150;
      if (scrollPoint < 0) scrollPoint = 0;
      $("html, body").animate(
        {
          scrollTop: scrollPoint
        },
        2000
      );
    }
  }
};
</script>
